"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Errors encountered when the client clock and server clock cannot agree on the
 * current time.
 *
 * These errors are retryable, assuming the SDK has enabled clock skew
 * correction.
 */
exports.CLOCK_SKEW_ERROR_CODES = {
    AuthFailure: true,
    InvalidSignatureException: true,
    RequestExpired: true,
    RequestInTheFuture: true,
    RequestTimeTooSkewed: true,
    SignatureDoesNotMatch: true
};
/**
 * Errors encountered when the state presumed by an operation is not yet ready.
 */
exports.STILL_PROCESSING_ERROR_CODES = {
    PriorRequestNotComplete: true
};
/**
 * Errors that indicate the SDK is being throttled.
 *
 * These errors are always retryable.
 */
exports.THROTTLING_ERROR_CODES = {
    BandwidthLimitExceeded: true,
    ProvisionedThroughputExceededException: true,
    RequestLimitExceeded: true,
    RequestThrottled: true,
    RequestThrottledException: true,
    SlowDown: true,
    ThrottledException: true,
    Throttling: true,
    ThrottlingException: true,
    TooManyRequestsException: true
};
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/service-error-classification/build/constants.js
// module id = IR9I
// module chunks = 0